module.exports = __webpack_public_path__ + "static/media/afwerking.22dc1376.svg";